<!-- <section class="banner">
  <div #air id="air" class="air"></div>
  <div class="head-component-ui">
    <div class="searchbar" data-aos="fade-down">
      <div class="hometitle mob-view pos-rel">
        <span class="sstarabicbold text-mobile-size search-txt">
          {{ "Knowledge portal" | translator }}
        </span>
        <span class="sstarabicbold header-capsoul">
          <div class="pi pi-times-circle m-l-2" routerLink="/home" style="cursor: pointer"></div>

          <i class="pi pi-book m-l-2" style="font-size: 1rem" aria-hidden="true"></i>
          {{ "Knowledge Library" | translator }}
        </span>
      </div>

      <div class="">
        <div class="" style="position: relative">
          <form (ngSubmit)="handleSubmit($event)">
            <span class="p-input-icon-right w-100">
              <i class="pi pi-search" style="margin-right: 10px; width: 30px"></i>
              <input pInputText name="search"
                class="form-control header-input-ui form-control-lg px-5 shadow-sm sstarabicbold" type="text" dir="rtl"
                filterButton [(ngModel)]="filters.search" (ngModelChange)="handleFilter()"
                placeholder="{{ 'Research' | translator }}" />
            </span>
          </form>
        </div>
      </div>
    </div>
  </div>
</section> -->





<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
  [showBreadCrums]="false"
  statsLayout="tiles"
  [compact]="true"
></app-admin-header>

<!-- Filters -->
<div class="container-fluid cu-page">
  <div class="cu-filter-card">
    <div class="row g-3">
      <div class="col-lg-5 col-12">
        <div class="cu-search">
          <input type="text" [(ngModel)]="searchText" (keydown.enter)="getContentUpdates()"
            placeholder="{{ 'Search by service name' | translator }}" />
          <i class="pi pi-search"></i>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <p-multiSelect class="cu-select" styleClass="w-100" [options]="ouTypes" [(ngModel)]="typeFilter"
          placeholder="{{ 'Choose content type' | translator }}" (onChange)="onTypeFilterChange()" [filter]="true"
          optionLabel="label" optionValue="value" appendTo="body" [showClear]="true" [maxSelectedLabels]="2"
          selectedItemsLabel="{0} {{ 'items selected' | translator }}">
          <ng-template let-item pTemplate="item">
            <div class="d-flex align-items-center">
              <i [ngClass]="item.icon" class="mx-1"></i>
              <span>{{ item.label }}</span>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <p-treeSelect class="cu-select" containerStyleClass="w-100" [(ngModel)]="oufilter"
          [options]="selectedTreeData" appendTo="body" (onNodeSelect)="filterFunctionByPostOuFilter($event)"
          placeholder="{{ 'Choose entity' | translator }}" [filter]="true" [filterInputAutoFocus]="true">
          <ng-template let-node pTemplate="default">
            <div class="d-flex align-items-center">
              <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
                class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
              <ng-template #elseBlock>
                <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
              </ng-template>
              <b class="text-nowrap">{{ node.label }}</b>
            </div>
          </ng-template>
        </p-treeSelect>
      </div>
    </div>

    <div class="row g-3 mt-1">
      <div class="col-lg-3 col-md-6 col-12">
        <label class="cu-label"><i class="pi pi-calendar"></i>{{ "starting date" | translator }}</label>
        <p-calendar class="cu-calendar" styleClass="w-100" panelStyleClass="cu-datepicker" appendTo="body" dir="ltr" [showIcon]="true"
          [(ngModel)]="start_date"></p-calendar>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <label class="cu-label"><i class="pi pi-calendar"></i>{{ "Expiry date" | translator }}</label>
        <p-calendar class="cu-calendar" styleClass="w-100" panelStyleClass="cu-datepicker" appendTo="body" dir="ltr" [showIcon]="true"
          [minDate]="start_date" [(ngModel)]="end_date"></p-calendar>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <label class="cu-label"><i class="fa-solid fa-user-check"></i>{{ "Request before" | translator }}</label>
        <p-dropdown class="cu-select" styleClass="w-100" [options]="contentUpdateUsers?.updated_by"
          [(ngModel)]="updatedBy" [filter]="true" filterBy="name" optionLabel="name" appendTo="body"
          [showClear]="true" placeholder="{{ 'Choose' | translator }}"></p-dropdown>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <label class="cu-label"><i class="fa-solid fa-user-check"></i>{{ "Approved by" | translator }}</label>
        <p-dropdown class="cu-select" styleClass="w-100" [options]="contentUpdateUsers?.approved_by"
          [(ngModel)]="approvedBy" [filter]="true" filterBy="name" optionLabel="name" appendTo="body"
          [showClear]="true" placeholder="{{ 'Choose' | translator }}"></p-dropdown>
      </div>
    </div>

    <div class="cu-actions">
      <div class="cu-inline-group cu-actions-types">
        <h6 class="cu-group-title">{{ "Operation type" | translator }}</h6>
        <div class="cu-check-list">
          <label *ngFor="let option of typeOptions" class="cu-check">
            <input type="checkbox" [checked]="isTypeChecked(option.name)" (change)="toggleType(option.name)" />
            <span>{{ option.arabic }}</span>
          </label>
        </div>
      </div>
      <button class="cu-btn cu-btn-primary" (click)="getContentUpdates()">
        <i class="pi pi-search"></i>{{ "Search" | translator }}
      </button>
      <button class="cu-btn-link" (click)="refresh()">{{ "Clear filters" | translator }}</button>
    </div>

    <!-- Status applies as soon as a box is ticked. -->
    <div class="cu-checks">
      <div class="cu-check-group cu-inline-group">
        <h6 class="cu-group-title">{{ "Status" | translator }}</h6>
        <div class="cu-check-list">
          <label *ngFor="let option of statusOptions" class="cu-check">
            <input type="checkbox" [checked]="isStatusChecked(option.name)" (change)="toggleStatus(option.name)" />
            <span>{{ option.arabic }}</span>
          </label>
        </div>
      </div>
      <button class="cu-btn cu-btn-outline cu-download" (click)="exportExcel()" [disabled]="downloadExcel">
        <i class="pi" [ngClass]="downloadExcel ? 'pi-spin pi-spinner' : 'pi-download'"></i>
        {{ "Download results" | translator }}
      </button>
    </div>
  </div>
</div>

<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="8" class="mb-2"></app-skelitions>
<!-- skelition  END -->

<div [hidden]="skelition" class="container-fluid">
  <div class="container-fluid mob-bottom-p" style="transform: scale(0.95, 0.95)">
    <div [hidden]="skelition" class="row p-bottom">
      <span [hidden]="data?.length > 0">
        <!-- <app-no-data [hidden]="data?.length > 0"></app-no-data> -->
        <div [hidden]="data?.length > 0" class="container-fluid">
          <div class="container d-flex justify-content-center">
            <h5 class="la-tujad">
              {{ "There is no data" | translator
              }}<i class="pi pi-fw pi-exclamation-triangle font-2rem mx-2"></i>
            </h5>
          </div>
        </div>
      </span>
      <!-- scroll view -->
      <div [ngClass]="{
            'col-lg-6 col-md-6 col-12 fixed-column slide-right': side_view,
            'col-lg-12 col-md-12 col-12': !side_view
          }">
          <div class="{{!side_view ? 'col-6-bg-defualt': 'col-6-bg-defualt'}}">
        <span *ngIf="data?.length > 0" class="{{!side_view ? 'd-flex align-items-center defualt-head-box': 'd-flex align-items-center white-head-box'}} ">
          <img class="svg-icon-heading" src="../../../../../assets/v-4-icone/Layer-2.svg" alt="loading" />
          <h5 class="heading mx-2">
            {{ getStatusLabel() }}
            <!-- {{ "update requests" | translator }} -->
          </h5>
        </span>
        <div class="{{ side_view ? 'v4-height' : '' }}">
          <div class="{{ side_view ? 'v4-scroll' : '' }}">

            <!-- Shared: reason, rejection summary, contact/party info, approve buttons, dialogs — rendered inside each parent accordion via ngTemplateOutlet -->
            <ng-template #sharedLogFooter let-log>
              <hr *ngIf="!!log.reason" />
              <div class="data-bg-light" *ngIf="!!log.reason">
                <h6>
                  <b [ngClass]="getTextClass(log, 3)"><i class="pi pi-exclamation-circle mx-2"></i>{{ "Reason" |
                    translator }}</b>
                </h6>
                <span [ngClass]="getTextClass(log, 3)" [innerHTML]="log.reason | safeHTML"></span>
              </div>

              <hr />

              <div class="mx-3" *ngIf="log.status == 'REJECTED'">
                <h6>
                  <b [ngClass]="getTextClass(log, 1)">{{
                    "the reason of refuse" | translator
                    }}</b>
                </h6>
                <span [ngClass]="getTextClass(log, 1)" [innerHTML]="log.reject_reason | safeHTML"></span>
              </div>

              <p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="rejectionModal"
                [style]="{ width: '95vw', maxWidth: '1000px' }">
                <ng-template pTemplate="header">
                  <span class="text-xl font-bold">{{
                    "Confirmation message" | translator
                    }}</span>
                </ng-template>
                <p>
                  {{
                  "Are you sure you want to decline the update request?"
                  | translator
                  }}
                </p>
                <label>{{ "the reason of refuse" | translator }} :</label>
                <p-editor [(ngModel)]="reason" class="question-p-editor" [style]="{ height: '120px' }"></p-editor>
                <ng-template pTemplate="footer">
                  <p-button [disabled]="reason == undefined" icon="pi pi-check" (click)="RejectLog(log)"
                    label="{{ 'OK' | translator }}" styleClass="p-button-text"></p-button>
                </ng-template>
              </p-dialog>

              <div class="w-100 data-bg-light">
                <div class="flex align-items-center">
                  <span>
                    <h6>
                      <b [ngClass]="getTextClass(log, 3)"><i class="pi pi-user-edit mx-2"></i>
                        {{ "Request before" | translator }} :
                      </b>
                      <span [ngClass]="getTextClass(log, 3)">
                        {{ log?.updated_by?.name.first }}
                        {{ log?.updated_by?.name.middle }}
                        {{ log?.updated_by?.name?.last }}
                      </span>
                    </h6>
                    <h6>
                      <b [ngClass]="getTextClass(log, 3)"><i class="fa-solid fa-envelope mx-2"></i>
                        {{ "Email" | translator }} :
                      </b>
                      <span [ngClass]="getTextClass(log, 3)">
                        {{ log.updated_by?.email }}
                      </span>
                    </h6>
                    <h6>
                      <b [ngClass]="getTextClass(log, 3)"><i class="fa fa-solid fa-phone mx-2"></i>
                        {{ "Phone Number" | translator }} :
                      </b>
                      <span [ngClass]="getTextClass(log, 3)">
                        {{ log.updated_by?.phone }}
                      </span>
                    </h6>
                    <h6>
                      <b [ngClass]="getTextClass(log, 3)"><i class="fa fa-solid fa-location-dot mx-2"></i>
                        {{ "City" | translator }} :
                      </b>
                      <span [ngClass]="getTextClass(log, 3)">
                        {{ log.updated_by?.location?.name }}
                      </span>
                    </h6>
                  </span>

                  <span *ngIf="log?.status != 'PENDING'">
                    <h6>
                      <b [ngClass]="getTextClass(log, 3)"><i class="fa-solid fa-user-check mx-2"></i>
                        <span [ngClass]="getTextClass(log, 3)" *ngIf="log?.status == 'APPROVED'">{{ "Approved by" | translator
                          }} :</span>
                        <span [ngClass]="getTextClass(log, 3)" *ngIf="log?.status != 'APPROVED'">{{ "Rejected before" |
                          translator }} :</span>
                      </b>
                      <span [ngClass]="getTextClass(log, 3)">
                        {{ log?.approved_by?.name?.first }}
                        {{ log?.approved_by?.name?.middle }}
                        {{ log?.approved_by?.name?.last }}
                      </span>
                    </h6>

                    <h6>
                      <b [ngClass]="getTextClass(log, 3)"><i class="fa-solid fa-envelope mx-2"></i>
                        {{ "Email" | translator }} :
                      </b>
                      <span [ngClass]="getTextClass(log, 3)">
                        {{ log.approved_by?.email }}
                      </span>
                    </h6>
                    <h6>
                      <b [ngClass]="getTextClass(log, 3)"><i class="fa fa-solid fa-phone mx-2"></i>
                        {{ "Phone Number" | translator }} :
                      </b>
                      <span [ngClass]="getTextClass(log, 3)">
                        {{ log.approved_by?.phone }}
                      </span>
                    </h6>
                    <h6>
                      <b [ngClass]="getTextClass(log, 3)"><i class="fa fa-solid fa-location-dot mx-2"></i>
                        {{ "City" | translator }} :
                      </b>
                      <span [ngClass]="getTextClass(log, 3)">
                        {{ log.approved_by?.location?.name }}
                      </span>
                    </h6>
                  </span>

                  <h6 *ngIf="log?.status != 'PENDING'">
                    <b [ngClass]="getTextClass(log, 3)">
                      <i class="pi pi-calendar-plus mx-2"></i>
                      <span *ngIf="log?.status == 'APPROVED'">
                        {{ "approval date" | translator }} :
                      </span>
                      <span *ngIf="log?.status != 'APPROVED'">
                        {{ "Date of rejection" | translator }} :
                      </span>
                    </b>
                    <span [ngClass]="getTextClass(log, 3)">
                      {{ log?.updatedAt | date }}
                    </span>
                  </h6>
                </div>
              </div>
              <div *ngIf="log?.status == 'PENDING' && hasPermission()"
                class="w-100 d-flex justify-content-end p-0 my-2">
                <button class="v4-mini-btn v4-mini-btn--approve">
                  <i (click)="confirmApprove(log)" class="pi pi-check"></i>
                </button>
                <button class="v4-mini-btn v4-mini-btn--reject">
                  <i (click)="confirmReject()" class="pi pi-times"></i>
                </button>
              </div>

              <p-dialog appendTo="body" header="Header" [(visible)]="rejectionModal"
                [style]="{ width: '95vw', maxWidth: '1000px' }">
                <ng-template pTemplate="header">
                  <span class="text-xl font-bold">{{
                    "Confirmation message" | translator
                    }}</span>
                </ng-template>
                <p [ngClass]="getTextClass(log, 1)">
                  {{
                  "Are you sure you want to decline the update request?"
                  | translator
                  }}
                </p>
                <label [ngClass]="getTextClass(log, 1) + ' mb-2'">{{ "the reason of refuse" | translator }} :</label>
                <p-editor [(ngModel)]="reason" [style]="{ height: '120px' }"></p-editor>
                <ng-template pTemplate="footer">
                  <button class="v4-btn-every py-2" [disabled]="reason == undefined" icon="" (click)="RejectLog(log)">
                    {{ "OK" | translator }}<i class="pi pi-check v4-ml-2"></i>
                  </button>
                </ng-template>
              </p-dialog>
            </ng-template>

            <div *ngFor="let log of data" (click)="openLog(log)" class="{{
                  (log.status == 'PENDING' || log.status == 'APPROVED') &&
                  log._id == selectedViewId
                    ? 'logs-box'
                    : 'log-default'
                }}" id="{{log._id}}">

                
              <!-- Edit Log -->
              <span *ngIf="log.type == 'EDIT'">
                <span class="d-flex align-items-center my-2 log-type">
                  <img class="{{log._id == this.selectedViewId ? 'width-30' : 'svg-icon'}}" src="../../../../../assets/v-4-icone/Layer1.svg" alt="loading" />
                  <span [ngClass]="getTextClass(log, 1) + ' mx-2'">{{
                    "Release" | translator
                    }}</span>
                </span>
                <span *ngIf="log.status == 'PENDING'">
                  <p-accordion class=" w-full" class="{{getClass(log) }}" (onOpen)="openLog(log)" (onClose)="openLog(log)"
                    [multiple]="true">
                    <p-accordionTab class="my-3" class="{{getClass(log) }}">
                      <ng-template pTemplate="header" class="{{getClass(log)
                  }}">
                        <div class="container-fluid flex-mob-web">
                          <div class="d-flex align-items-center color-grey">
                            <i [ngClass]="
                                  log?.before?.dataview.type?.icon +
                                  ' font-1_2rem'
                                " class="m-2"></i>
                            <span class="vertical-align-middle font-1_1rem d-flex">{{ log?.before?.name }} ({{
                              log?.before?.dataview.type?.arabic
                              }})</span>
                            <button
                              type="button"
                              pButton
                              class="p-button-rounded p-button-outlined p-button-sm ms-2"
                              (click)="copyNameWithType(log?.before?.name, log?.before?.dataview?.type?.arabic); $event.stopPropagation()"
                              [label]="''"
                              pTooltip="{{ 'Copy' | translator }}"
                              tooltipPosition="top"
                            >
                              <i class="pi pi-copy"></i>
                            </button>
                          </div>
                          <div class="mob-mr d-flex flex-column align-items-end">
                            <span class="color-grey">({{ log.createdAt | date : 'MMM d, y, h:mm:ss a' }})</span>
                            <span *ngIf="log?.serviceLastUpdatedAt" class="color-grey small">{{ "Last updated" | translator }}: {{ log.serviceLastUpdatedAt | date : 'MMM d, y, h:mm:ss a' }}</span>
                          </div>
                        </div>
                      </ng-template>
                      <!-- Name Is Edited -->
                      <ng-template class="{{getClass(log)}}" pTemplate="content">
                        <div [hidden]="log?.after.name == log?.before?.name">
                          <span [ngClass]="getTextClass(log, 1)"><i class="pi pi-pencil mx-2"></i>{{ "Update address" | translator
                            }}:</span>
                          {{ log?.after?.name }}
                        </div>
                        <!-- End Name Is Edited -->
                        <p-accordion class="w-full" [multiple]="true">
                          <span *ngFor="
                                let field of log?.after?.fields;
                                let i = index
                              ">
                            <p-accordionTab class="my-3 2222" *ngIf="field?.wasEdited" iconPos="end">
                              <ng-template pTemplate="header">
                                <div class="d-flex align-items-center color-grey">
                                  <p-checkbox (click)="$event.stopPropagation()" [(ngModel)]="field.isChecked"
                                    class="shadow" [binary]="true" inputId="binary"></p-checkbox>

                                  <i [ngClass]="
                                        field?.label?.icon + ' font-1_2rem'
                                      " class="m-2"></i>
                                  <span class="vertical-align-middle font-1_1rem">{{ field?.label?.name }}</span>
                                </div>
                              </ng-template>
                              <ng-template pTemplate="content">
                                <div class="d-flex justify-content-between">
                                  <div class="w-100" [ngSwitch]="
                                        getFieldType(field?.label?.type)
                                      ">
                                    <!-- For text -->
                                    <div *ngSwitchCase="'text'">
                                      <i class="pi pi-clone"></i>
                                      <input pInputText [(ngModel)]="field.data" class="w-100" [id]="field?.label"
                                        type="text" />
                                    </div>
                                    <!-- Rich text -->
                                    <div *ngSwitchCase="'Rich text'">
                                      <p-editor class="question-p-editor" [(ngModel)]="field.data" [style]="{ height: '320px' }"></p-editor>
                                    </div>
                                    <div *ngSwitchCase="'Upload Image'">
                                      <img [hidden]="field.data == ''" class="img-fluid upload-img-dActive" [src]="
                                            GlobalConstants.staticFilesURL +
                                            field.data
                                          " />
                                      <p-fileUpload mode="basic" chooseLabel="Choose" name="file"
                                        [url]="apilink + 'file/data'" [auto]="true" chooseLabel="Browse"
                                        accept="image/*" [maxFileSize]="1000000" (onUpload)="
                                            field.data =
                                              $event.originalEvent.body.data
                                          "></p-fileUpload>
                                    </div>
                                    <div *ngSwitchCase="'Upload Document'">
                                      <a class="doc-view-dActive" [hidden]="field.data == ''" target="_blank" [href]="
                                            GlobalConstants.staticFilesURL +
                                            field.data
                                          ">
                                        <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                        translator }}
                                      </a>
                                      <p-fileUpload mode="basic" chooseLabel="Choose" name="file"
                                        [url]="apilink + 'file/data'" [auto]="true" chooseLabel="Add File"
                                        [maxFileSize]="100000000" (onUpload)="
                                            field.data =
                                              $event.originalEvent.body.data
                                          "></p-fileUpload>
                                    </div>
                                    <div *ngSwitchCase="'Data Item'">
                                      <button type="submit" (click)="toggleModal(i)" pButton pRipple
                                        label="{{ 'to update' | translator }}" icon="pi pi-fw pi-plus-circle"
                                        class="w-full my-3"></button>
                                      <p-dialog [blockScroll]="true" [draggable]="false"
                                        header="{{ 'Select' | translator }}" [(visible)]="modalVisibilities[i]" [style]="{
                                            width: '95vw',
                                            maxWidth: '1000px'
                                          }">
                                        <app-select-service (currentDataItem)="
                                              changeCurrentDataItem(
                                                $event,
                                                field,
                                                i
                                              )
                                            "></app-select-service>
                                      </p-dialog>
                                      <p class="font-bold" *ngIf="field.data">
                                        {{ field.data.name }}
                                      </p>
                                    </div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </div>
                              </ng-template>
                            </p-accordionTab>
                          </span>
                        </p-accordion>
                        <ng-container *ngTemplateOutlet="sharedLogFooter; context: { $implicit: log }"></ng-container>
                      </ng-template>
                    </p-accordionTab>
                  </p-accordion>
                </span>
                <span *ngIf="log.status == 'APPROVED' || log.status == 'REJECTED'">
                  <p-accordion (onOpen)="openLog(log)" (onClose)="openLog(log)" class="w-full {{getClass(log) }}" [multiple]="true">
                    <p-accordionTab class="my-3 {{getClass(log) }}">
                      <ng-template class="{{getClass(log) }}" pTemplate="header">
                        <div class="container-fluid flex-mob-web">
                          <div class="d-flex align-items-center color-grey">
                            <i [ngClass]="
                                  log?.before?.dataview?.type?.icon +
                                  ' font-1_2rem'
                                " class="m-2"></i>
                            <span class="vertical-align-middle font-1_1rem">{{ log?.before?.name }} <span>({{
                              log?.before?.dataview?.type?.arabic
                              }})</span></span>
                            <button
                              type="button"
                              pButton
                              class="p-button-rounded p-button-outlined p-button-sm ms-2"
                              (click)="copyNameWithType(log?.before?.name, log?.before?.dataview?.type?.arabic); $event.stopPropagation()"
                              [label]="''"
                              pTooltip="{{ 'Copy' | translator }}"
                              tooltipPosition="top"
                            >
                              <i class="pi pi-copy"></i>
                            </button>
                          </div>
                          <div class="mob-mr d-flex flex-column align-items-end">
                            <span class="color-grey">({{ log.createdAt | date: 'MMM d, y, h:mm:ss a' }})</span>
                            <span *ngIf="log?.serviceLastUpdatedAt" class="color-grey small">{{ "Last updated" | translator }}: {{ log.serviceLastUpdatedAt | date: 'MMM d, y, h:mm:ss a' }}</span>
                          </div>
                        </div>
                      </ng-template>
                      <!-- Name Is Edited -->
                      <ng-template class="{{getClass(log) }}" pTemplate="content">
                        <p [ngClass]="getTextClass(log, 1) + ' mx-2'">
                          {{ "User updates" | translator }}
                        </p>
                        <div [hidden]="log?.after?.name == log?.before?.name">
                          <span [ngClass]="getTextClass(log, 1)"><i class="pi pi-pencil mx-2"></i>{{ "Address update" | translator
                            }}:&nbsp;</span>
                          &nbsp;{{ log?.after?.name }}
                        </div>
                        <!-- End Name Is Edited -->

                        <p-accordion class="w-full" [multiple]="true">
                          <span *ngFor="
                                let field of log.after?.fields;
                                let i = index
                              ">
                            <p-accordionTab class="my-3 4444" *ngIf="field.wasEdited" iconPos="end">
                              <ng-template pTemplate="header">
                                <div class="d-flex align-items-center justify-content-between w-100 color-grey">
                                  <span>
                                    <i [ngClass]="
                                          field.label?.icon + ' font-1_2rem'
                                        " class="m-2"></i>
                                    <span class="vertical-align-middle font-1_1rem">{{ field.label?.name }}</span>
                                  </span>
                                  <span *ngIf="!field.isChecked" class="d-flex">
                                    <i class="times-cross pi pi-times"></i>
                                  </span>
                                </div>
                              </ng-template>
                              <ng-template pTemplate="content">
                                <div class="">
                                  <div [ngSwitch]="
                                        getFieldType(field.label?.type)
                                      ">
                                    <!-- For text -->
                                    <div *ngSwitchCase="'text'">
                                      <div class="d-flex flex-column mb-0 datacontent edited" *ngIf="field.data"
                                        [innerHTML]="field.data | safeHTML"></div>
                                    </div>
                                    <!-- Rich text -->
                                    <div *ngSwitchCase="'Rich text'">
                                      <div class="d-flex flex-column mb-0 datacontent edited" *ngIf="field.data"
                                        [innerHTML]="field.data | safeHTML"></div>
                                    </div>
                                    <div *ngSwitchCase="'Upload Image'">
                                      <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                            GlobalConstants.staticFilesURL +
                                            field.data
                                          " />
                                    </div>
                                    <div *ngSwitchCase="'Upload Document'">
                                      <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                            GlobalConstants.staticFilesURL +
                                            field.data
                                          ">
                                        <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                        translator }}
                                      </a>
                                    </div>
                                    <div *ngSwitchCase="'Data Item'">
                                      <p [ngClass]="getTextClass(log, 1) + ' mx-2'">
                                        {{ field?.data?.name }}
                                      </p>
                                      <p-accordion class="w-100" [multiple]="true">
                                        <p-accordionTab class="my-3 5555" *ngFor="
                                              let field of field.data.fields;
                                              let i = index
                                            " iconPos="end">
                                          <ng-template pTemplate="header">
                                            <div class="d-flex align-items-center color-grey">
                                              <i [ngClass]="
                                                    field.label?.icon +
                                                    ' font-1_2rem'
                                                  " class="m-2"></i>
                                              <span class="vertical-align-middle font-1_1rem">{{ field.label?.name }}</span>
                                            </div>
                                          </ng-template>
                                          <ng-template pTemplate="content">
                                            <div class="row">
                                              <div class="col-10">
                                                <div [ngSwitch]="
                                                      getFieldType(
                                                        field.label?.type
                                                      )
                                                    ">
                                                  <!-- For text -->
                                                  <div *ngSwitchCase="'text'">
                                                    <div class="d-flex flex-column mb-0 datacontent edited" *ngIf="field.data"
                                                      [innerHTML]="
                                                          field.data | safeHTML
                                                        "></div>
                                                  </div>
                                                  <!-- Rich text -->
                                                  <div *ngSwitchCase="'Rich text'">
                                                    <div class="d-flex flex-column mb-0 datacontent edited" *ngIf="field.data"
                                                      [innerHTML]="
                                                          field.data | safeHTML
                                                        "></div>
                                                  </div>
                                                  <div *ngSwitchCase="'Upload Image'">
                                                    <img [hidden]="
                                                          field.data == ''
                                                        " class="img-fluid upload-img" [src]="
                                                          GlobalConstants.staticFilesURL +
                                                          field.data
                                                        " />
                                                  </div>
                                                  <div *ngSwitchCase="'Upload Document'">
                                                    <a class="doc-view" [hidden]="
                                                          field.data == ''
                                                        " target="_blank" [href]="
                                                          GlobalConstants.staticFilesURL +
                                                          field.data
                                                        ">
                                                      <i [hidden]="
                                                            field.data == ''
                                                          " class="pi pi-file mx-2"></i>{{
                                                      "Add file"
                                                      | translator
                                                      }}
                                                    </a>
                                                  </div>
                                                  <div *ngSwitchCase="'Data Item'"></div>
                                                  <div *ngSwitchDefault>
                                                    {{ field.data }}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </ng-template>
                                        </p-accordionTab>
                                      </p-accordion>
                                    </div>
                                    <div *ngSwitchDefault>
                                      {{ field.data }}
                                    </div>
                                  </div>
                                </div>
                              </ng-template>
                            </p-accordionTab>
                          </span>
                          <span *ngIf="log?.adminChange?.fields.length > 0">
                            <p [ngClass]="getTextClass(log, 1) + ' mx-2'">
                              {{ "Management updates" | translator }}
                            </p>
                            <span *ngFor="
                                  let field of log.adminChange?.fields;
                                  let i = index
                                ">
                              <p-accordionTab class="my-3 6666" *ngIf="field.isChecked" iconPos="end">
                                <ng-template pTemplate="header">
                                  <div class="d-flex align-items-center color-grey">
                                    <i [ngClass]="
                                          field.label?.icon + ' font-1_2rem'
                                        " class="m-2"></i>
                                    <span class="vertical-align-middle font-1_1rem">{{ field.label?.name }}</span>
                                  </div>
                                </ng-template>
                                <ng-template pTemplate="content">
                                  <div class="">
                                    <div [ngSwitch]="
                                          getFieldType(field.label?.type)
                                        ">
                                      <!-- For text -->
                                      <div *ngSwitchCase="'text'">
                                        <div class="d-flex flex-column mb-0 datacontent edited" *ngIf="field.data"
                                          [innerHTML]="field.data | safeHTML"></div>
                                      </div>
                                      <!-- Rich text -->
                                      <div *ngSwitchCase="'Rich text'">
                                        <div class="d-flex flex-column mb-0 datacontent edited" *ngIf="field.data"
                                          [innerHTML]="field.data | safeHTML"></div>
                                      </div>
                                      <div *ngSwitchCase="'Upload Image'">
                                        <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                              GlobalConstants.staticFilesURL +
                                              field.data
                                            " />
                                      </div>
                                      <div *ngSwitchCase="'Upload Document'">
                                        <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                              GlobalConstants.staticFilesURL +
                                              field.data
                                            ">
                                          <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                          translator }}
                                        </a>
                                      </div>
                                      <div *ngSwitchCase="'Data Item'">
                                        <p>{{ field?.data?.name }}</p>
                                        <p-accordion class="w-full" [multiple]="true">
                                          <p-accordionTab class="my-3 7777" *ngFor="
                                                let field of field.data.fields;
                                                let i = index
                                              " iconPos="end">
                                            <ng-template pTemplate="header">
                                              <div class="d-flex align-items-center color-grey">
                                                <i [ngClass]="
                                                      field.label?.icon +
                                                      ' font-1_2rem'
                                                    " class="m-2"></i>
                                                <span class="vertical-align-middle font-1_1rem">{{ field.label?.name }}</span>
                                              </div>
                                            </ng-template>
                                            <ng-template pTemplate="content">
                                              <div class="row">
                                                <div class="col-10">
                                                  <div [ngSwitch]="
                                                        getFieldType(
                                                          field.label?.type
                                                        )
                                                      ">
                                                    <!-- For text -->
                                                    <div *ngSwitchCase="'text'">
                                                      <div class="d-flex flex-column mb-0 datacontent edited"
                                                        *ngIf="field.data" [innerHTML]="
                                                            field.data
                                                              | safeHTML
                                                          "></div>
                                                    </div>
                                                    <!-- Rich text -->
                                                    <div *ngSwitchCase="
                                                          'Rich text'
                                                        ">
                                                      <div class="d-flex flex-column mb-0 datacontent edited"
                                                        *ngIf="field.data" [innerHTML]="
                                                            field.data
                                                              | safeHTML
                                                          "></div>
                                                    </div>
                                                    <div *ngSwitchCase="
                                                          'Upload Image'
                                                        ">
                                                      <img [hidden]="
                                                            field.data == ''
                                                          " class="img-fluid upload-img" [src]="
                                                            GlobalConstants.staticFilesURL +
                                                            field.data
                                                          " />
                                                    </div>
                                                    <div *ngSwitchCase="
                                                          'Upload Document'
                                                        ">
                                                      <a class="doc-view" [hidden]="
                                                            field.data == ''
                                                          " target="_blank" [href]="
                                                            GlobalConstants.staticFilesURL +
                                                            field.data
                                                          ">
                                                        <i [hidden]="
                                                              field.data == ''
                                                            " class="pi pi-file mx-2"></i>{{
                                                        "Add file"
                                                        | translator
                                                        }}
                                                      </a>
                                                    </div>
                                                    <div *ngSwitchCase="
                                                          'Data Item'
                                                        "></div>
                                                    <div *ngSwitchDefault>
                                                      {{ field.data }}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </ng-template>
                                          </p-accordionTab>
                                        </p-accordion>
                                      </div>
                                      <div *ngSwitchDefault>
                                        {{ field.data }}
                                      </div>
                                    </div>
                                  </div>
                                </ng-template>
                              </p-accordionTab>
                            </span>
                          </span>
                        </p-accordion>
                        <ng-container *ngTemplateOutlet="sharedLogFooter; context: { $implicit: log }"></ng-container>
                      </ng-template>
                    </p-accordionTab>
                  </p-accordion>
                </span>
              </span>
              <!-- End Edit Log -->

              <!-- Delete Log -->
              <span *ngIf="log.type == 'DELETE'">
                <div class="flex-align-flex">
                  <span class="my-2 log-type">
                    <img [ngClass]="getTextClass(log, 4)" src="../assets/icons/delete/24-@1.5x.svg" alt="loading" />
                    <span [ngClass]="getTextClass(log, 1) + ' mx-2'">{{
                      "delete" | translator
                      }}</span>

                  </span>
                  <span>
                    <!--  -->
                    <i pTooltip="{{'Undo delete' | translator}}" tooltipPosition="top" (click)="confirmUndoDelete(log)"
                      *ngIf="log.status == 'APPROVED' && !log.isUndoDelete" class="pi pi-reply v4-pi-rep"></i>
                    <span *ngIf="log.status == 'APPROVED' && log.isUndoDelete"
                      class="pi pi-check-square v4-pi-rep">{{'Returned' | translator}}</span>
                  </span>
                </div>
                <p-accordion (onOpen)="openLog(log)" (onClose)="openLog(log)" class="w-full" class="{{getClass(log) }}" [multiple]="true">
                  <p-accordionTab class="my-3" class="{{getClass(log) }}">
                    <ng-template pTemplate="header">
                      <div class="container-fluid flex-mob-web">
                        <div class="d-flex align-items-center color-grey">
                          <i [ngClass]="
                                log?.before?.dataview?.type?.icon +
                                ' font-1_2rem'
                              " class="m-2"></i>
                          <span class="vertical-align-middle font-1_1rem d-flex">{{ log?.before?.name }} ({{
                            log?.before?.dataview?.type?.arabic
                            }})</span>
                          <button
                            type="button"
                            pButton
                            class="p-button-rounded p-button-outlined p-button-sm ms-2"
                            (click)="copyNameWithType(log?.before?.name, log?.before?.dataview?.type?.arabic); $event.stopPropagation()"
                            [label]="''"
                            pTooltip="{{ 'Copy' | translator }}"
                            tooltipPosition="top"
                          >
                            <i class="pi pi-copy"></i>
                          </button>
                        </div>
                        <div class="mob-mr d-flex flex-column align-items-end">
                          <span class="color-grey">({{ log.createdAt | date : 'MMM d, y, h:mm:ss a' }})</span>
                          <span *ngIf="log?.serviceLastUpdatedAt" class="color-grey small">{{ "Last updated" | translator }}: {{ log.serviceLastUpdatedAt | date : 'MMM d, y, h:mm:ss a' }}</span>
                        </div>
                      </div>
                    </ng-template>
                    <!-- Name Is Edited -->
                    <ng-template pTemplate="content">
                      <p [ngClass]="getTextClass(log, 1)">
                        <i class="pi pi-trash"></i>&nbsp;{{
                        "Delete request" | translator
                        }}&nbsp;
                      </p>
                      <ng-container *ngTemplateOutlet="sharedLogFooter; context: { $implicit: log }"></ng-container>
                    </ng-template>
                  </p-accordionTab>
                </p-accordion>
              </span>
              <!-- End Delete log -->

              <!-- Add Service -->
              <span *ngIf="log?.type == 'ADD SERVICE'">
                <span class="d-flex mt-2 log-type">
                  <img [ngClass]="getTextClass(log, 4)" src="../assets/icons/Add/24@1.5x.svg" alt="loading" />
                  <span [ngClass]="getTextClass(log, 1) + ' vertical-align-middle m-2'">{{
                    "Add data" | translator
                    }}</span>
                </span>
                <p-accordion (onOpen)="openLog(log)" (onClose)="openLog(log)">
                  <p-accordionTab class="9999">
                    <ng-template pTemplate="header">
                      <div class="flex align-items-center w-100">
                        <div class="d-flex justify-content-between align-items-center w-100 color-grey">
                          <div class="d-flex">
                            <!-- <i [ngClass]="'pi pi-plus-circle'" class="m-2"></i>
                                                        <span class="vertical-align-middle m-2">{{"Add data"| translator}}</span> -->
                            <i [ngClass]="
                                  getDataTypeIcon(log?.after.type) +
                                  ' font-1_2rem'
                                " class="m-2"></i>
                            <span class="vertical-align-middle font-1_1rem d-flex">
                              {{ getDataTypeName(log?.after.type) }}({{
                              log.after?.name
                              }})</span>
                            <button
                              type="button"
                              pButton
                              class="p-button-rounded p-button-outlined p-button-sm ms-2"
                              (click)="copyNameWithType(log?.after?.name, getDataTypeName(log?.after?.type)); $event.stopPropagation()"
                              [label]="''"
                              pTooltip="{{ 'Copy' | translator }}"
                              tooltipPosition="top"
                            >
                              <i class="pi pi-copy"></i>
                            </button>
                          </div>
                          <div class="d-flex flex-column align-items-end">
                            <span>({{ log?.createdAt | date }})</span>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <!-- User data changes-->
                    <div>
                      <div class="card-body">
                        <p-accordion class="w-full" [multiple]="true">
                          <p-accordionTab class="1000" *ngFor="
                                let field of log?.after.fields;
                                let i = index
                              " iconPos="end">
                            <ng-template pTemplate="header">
                              <div class="flex align-items-center">
                                <span class="vertical-align-middle m-2">{{
                                  field?.label
                                  }}</span>
                              </div>
                            </ng-template>
                            <ng-template pTemplate="content">
                              <!-- For PENDING logs  -->
                              <div *ngIf="log.status == 'PENDING'" class="">
                                <div class="flex-column mb-0 datacontent edited" [ngSwitch]="
                                      getDataTypeNameByDataFields(field.type)
                                    ">
                                  <!-- For text -->
                                  <div *ngSwitchCase="'text'">
                                    <span class="p-input-icon-right w-100">
                                      <i class="pi pi-clone"></i>
                                      <input pInputText [(ngModel)]="field.data" class="w-100" type="text" />
                                    </span>
                                  </div>
                                  <!-- Rich text -->
                                  <div class="w-100" *ngSwitchCase="'Rich text'">
                                    <p-editor [(ngModel)]="field.data" [style]="{ height: '120px' }"></p-editor>
                                  </div>
                                  <!-- Images -->
                                  <div *ngSwitchCase="'Upload Image'">
                                    <img [hidden]="field.data == ''" class="img-fluid" style="width: 100px" [src]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        " />
                                    <p-fileUpload mode="basic" chooseLabel="Choose" name="demo[]"
                                      [url]="apilink + 'files/ouImage'" [auto]="true" chooseLabel="Browse"
                                      accept="image/*" [maxFileSize]="1000000" (onUpload)="
                                          field.data =
                                            $event.originalEvent.body.URL
                                        "></p-fileUpload>
                                  </div>
                                  <!-- Document -->
                                  <div *ngSwitchCase="'Upload Document'">
                                    <a class="doc-view my-2" [hidden]="field.data == ''" target="_blank" [href]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        ">
                                      <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                      translator }}
                                    </a>
                                    <p-fileUpload mode="basic" chooseLabel="Choose" name="demo[]"
                                      [url]="apilink + 'files/upload-files'" [auto]="true" chooseLabel="Add File"
                                      [maxFileSize]="1000000" (onUpload)="
                                          field.data =
                                            $event.originalEvent.body.URL
                                        "></p-fileUpload>
                                  </div>
                                  <div *ngSwitchCase="'Data Item'">
                                    <button type="submit" (click)="toggleModal(i)" pButton pRipple
                                      label="{{ 'to update' | translator }}" icon="pi pi-fw pi-plus-circle"
                                      class="w-full my-3"></button>
                                    <p-dialog [blockScroll]="true" [draggable]="false"
                                      header="{{ 'Select' | translator }}" [(visible)]="modalVisibilities[i]" [style]="{
                                          width: '95vw',
                                          maxWidth: '1200px'
                                        }">
                                      <app-select-service (currentDataItem)="
                                            changeCurrentDataItem(
                                              $event,
                                              field,
                                              i
                                            )
                                          "></app-select-service>
                                    </p-dialog>
                                    <p class="font-bold" *ngIf="field.data">
                                      {{ field.data.name }}
                                    </p>
                                  </div>
                                  <div *ngSwitchDefault></div>
                                </div>
                              </div>
                              <!-- For APPROVED / REJECTED logs -->
                              <div *ngIf="log.status != 'PENDING'" class="d-flex justify-content-between">
                                <div class="d-flex flex-column mb-0 datacontent edited" [ngSwitch]="
                                      getDataTypeNameByDataFields(field.type)
                                    ">
                                  <!-- For text -->
                                  <div *ngSwitchCase="'text'">
                                    <span class="p-input-icon-right w-100">{{
                                      field.data
                                      }}</span>
                                  </div>
                                  <!-- Rich text -->
                                  <div *ngSwitchCase="'Rich text'">
                                    <span [innerHTML]="field.data | safeHTML" class="m-0"></span>
                                  </div>
                                  <!-- Images -->
                                  <div *ngSwitchCase="'Upload Image'">
                                    <img [hidden]="field.data == ''" class="img-fluid" style="width: 100px" [src]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        " />
                                  </div>
                                  <!-- Document -->
                                  <div *ngSwitchCase="'Upload Document'">
                                    <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        ">
                                      <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                      translator }}
                                    </a>
                                  </div>
                                  <div *ngSwitchCase="'Data Item'">
                                    <p [ngClass]="getTextClass(log, 1)">
                                      {{ field.data.name }}
                                    </p>
                                  </div>
                                  <div *ngSwitchDefault></div>
                                </div>
                              </div>
                            </ng-template>
                          </p-accordionTab>
                        </p-accordion>
                      </div>
                    </div>
                    <!-- Admin data changes-->
                    <div *ngIf="log.adminChange?.fields?.length > 0">
                      <div class="card-body">
                        <h4 class="card-title" style="font-weight: 600; color: var(--color-1)">
                          <i [class]="getDataTypeIcon(log.after.type)"></i>
                          {{ getDataTypeName(log.after.type) }}
                          ({{ "Update from management" | translator }})
                        </h4>
                        <p-accordion class="w-full" [multiple]="true" [activeIndex]="0">
                          <p-accordionTab class="1100" *ngFor="
                                let field of log.adminChange?.fields;
                                let i = index
                              " iconPos="end">
                            <ng-template pTemplate="header">
                              <div class="flex align-items-center">
                                <span class="vertical-align-middle m-2">{{
                                  field?.label
                                  }}</span>
                              </div>
                            </ng-template>
                            <ng-template pTemplate="content">
                              <!-- For Admin changes logs -->
                              <div class="d-flex justify-content-between">
                                <div class="d-flex flex-column mb-0 datacontent edited" [ngSwitch]="
                                      getDataTypeNameByDataFields(field.type)
                                    ">
                                  <!-- For text -->
                                  <div *ngSwitchCase="'text'">
                                    <span class="p-input-icon-right w-100">{{
                                      field.data
                                      }}</span>
                                  </div>
                                  <!-- Rich text -->
                                  <div *ngSwitchCase="'Rich text'">
                                    <span [innerHTML]="field.data | safeHTML" class="m-0"></span>
                                  </div>
                                  <!-- Images -->
                                  <div *ngSwitchCase="'Upload Image'">
                                    <img [hidden]="field.data == ''" class="img-fluid" style="width: 100px" [src]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        " />
                                  </div>
                                  <!-- Document -->
                                  <div *ngSwitchCase="'Upload Document'">
                                    <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                          GlobalConstants.staticFilesURL +
                                          field.data
                                        ">
                                      <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                      translator }}
                                    </a>
                                  </div>
                                  <!-- Data Item -->
                                  <div *ngSwitchCase="'Data Item'">
                                    <p class="font-bold" *ngIf="field.data">
                                      {{ field.data.name }}
                                    </p>
                                  </div>
                                  <div *ngSwitchDefault></div>
                                </div>
                              </div>
                            </ng-template>
                          </p-accordionTab>
                        </p-accordion>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="sharedLogFooter; context: { $implicit: log }"></ng-container>
                  </p-accordionTab>
                </p-accordion>
              </span>
              <!-- End Add Service -->

              <!-- Change Ou Logs -->
              <span *ngIf="log.type == 'OU CHANGE'">
                <span class="flex-align-flex mt-2 log-type">
                  <img [ngClass]="getTextClass(log, 4)" class="mx-2" src="../assets/icons/Edit/24-dark@1.5x.svg" alt="loading" />
                  <span [ngClass]="getTextClass(log, 1)">{{
                    "Change classification" | translator
                    }}</span>
                </span>
                <p-accordion (onOpen)="openLog(log)" (onClose)="openLog(log)" class="w-full {{getClass(log) }}" [multiple]="true">
                  <p-accordionTab class="my-3 {{getClass(log) }}">
                    <ng-template pTemplate="header">
                      <div class="container-fluid flex-mob-web">
                        <div class="d-flex align-items-center color-grey">
                          <i [ngClass]="
                                log?.before?.dataview?.type?.icon + ' font-1_2rem'
                              " class="m-2"></i>
                          <span class="vertical-align-middle font-1_1rem d-flex" [ngClass]="getTextClass(log, 1)">{{ log?.before?.name }} ({{
                            log?.before?.dataview?.type?.arabic
                            }})</span>
                          <button
                            type="button"
                            pButton
                            class="p-button-rounded p-button-outlined p-button-sm ms-2"
                            (click)="copyNameWithType(log?.before?.name, log?.before?.dataview?.type?.arabic); $event.stopPropagation()"
                            [label]="''"
                            pTooltip="{{ 'Copy' | translator }}"
                            tooltipPosition="top"
                          >
                            <i class="pi pi-copy"></i>
                          </button>
                        </div>
                        <div class="mob-mr d-flex flex-column align-items-end">
                          <span class="color-grey" [ngClass]="getTextClass(log, 1)">({{ log.createdAt | date : 'MMM d, y, h:mm:ss a' }})</span>
                          <span *ngIf="log?.serviceLastUpdatedAt" class="color-grey small">{{ "Last updated" | translator }}: {{ log.serviceLastUpdatedAt | date : 'MMM d, y, h:mm:ss a' }}</span>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <p [ngClass]="getTextClass(log, 1) + ' mx-2 mb-0'">
                        {{ "Before updating" | translator }}
                      </p>
                      <div class="d-flex flex-row align-items-center wrapp">
                        <span class="d-flex align-items-center my-1" *ngFor="
                              let item of sortBreadcrums(
                                log?.before?.dataview?.breadcrumbs
                              );
                              let i = index
                            " [routerLink]="item?.routerLink">
                          <span class="custom-bredcrum-btn d-flex align-items-center">
                            <i [hidden]="item?.image_sq" class="{{ item?.icon }} me-1"></i>
                            <img [hidden]="!item?.image_sq" [src]="staticURL + item?.image_sq"
                              style="max-height: 1.2rem; max-width: 1.2rem" class="blacknWhite img-fluid me-1" />
                            <span class="d-flex">{{ item?.label }}</span>
                          </span>
                          <span class=""><i class="pi pi-fw pi-angle-left color-grey"></i></span>
                        </span>
                      </div>
                      <p [ngClass]="getTextClass(log, 1) + ' mx-2 mb-0'">
                        {{ "After the update" | translator }}
                      </p>
                      <div class="d-flex flex-row align-items-center wrapp">
                        <span class="d-flex align-items-center my-1" *ngFor="
                              let item of sortBreadcrums(
                                log?.after?.newOu?.breadcrumb
                              );
                              let i = index
                            " [routerLink]="item?.routerLink">
                          <span style="background-color: #1e2253" class="custom-bredcrum-btn d-flex align-items-center">
                            <i [hidden]="item?.icon" class="{{ item?.icon }} me-1"></i>
                            <img [hidden]="!item?.icon" [src]="staticURL + item?.icon"
                              style="max-height: 1.2rem; max-width: 1.2rem" class="blacknWhite img-fluid me-1" />
                            <span class="inherit v4-color-white">{{ item?.label }}</span>
                          </span>
                          <span class=""><i class="pi pi-fw pi-angle-left color-grey"></i></span>
                        </span>
                      </div>
                      <ng-container *ngTemplateOutlet="sharedLogFooter; context: { $implicit: log }"></ng-container>
                    </ng-template>
                  </p-accordionTab>
                </p-accordion>
              </span>
              <!-- Change Ou Logs -->
            </div>
          </div>

          <div class="v4-pagination">
            <p-paginator class="v4-pagination" [hidden]="data?.length <= 0" appendTo="body"
              (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
              [rowsPerPageOptions]="[10, 20, 30]"></p-paginator>
          </div>
        </div>
      </div>
      </div>

      <!-- View Of the Service   'sticky-column': isScrolled && !showFilters,
            'filter-stickey': isScrolled && showFilters  [ngClass]="{ 'sticky-content': isScrolled }"-->
      <div *ngIf="side_view" [ngClass]="{
            'col-lg-6 col-md-6 col-12  slide-left': side_view,
            'class-for-false': !side_view,
         
          }" class="mob-top-wiew" [style.top]="topValue + 'px'"
        style="position: absolute !important; left: 0px !important">
        <div class="col-6-bg-defualt ">
          <span class="d-flex align-items-center red-head-box">
            <img class="svg-icon-heading" src="../../../../../assets/v-4-icone/Layer-3.svg" alt="loading" />
            <h5 class="heading mx-2">
              {{ "Content before update" | translator }}
            </h5>
          </span>
          <!-- Same scrolling body as the requests list, so both boxes match. -->
          <div class="v4-scroll">
            <div *ngIf="selectedLog?.serviceLastUpdatedAt" class="mx-2 mb-2">
              <span class="color-grey font-1_1rem"><i class="pi pi-calendar mx-1"></i>{{ "Last updated" | translator }}: {{ selectedLog.serviceLastUpdatedAt | date }}</span>
            </div>
            <div class="{{
                  hasStatus('PENDING') || hasStatus('APPROVED')
                    ? 'logs-box-view w-100'
                    : 'log-default w-100'
                }}">
              <div class="row my-2 d-flex align-items-center">
                <div class="col-md-12 col-12">
                  <div class="d-flex my-2">
                    <div class="column pos-rel w-100">
                      <h4 class="card-title mx-2 content-txt">
                        {{ side_view.name }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <!-- breadcrumb -->
              <div class="d-flex flex-row align-items-center wrapp">
                <span class="d-flex align-items-center my-1" *ngFor="let item of side_view?.breadcrumbs; let i = index"
                  [routerLink]="item?.routerLink">
                  <span class="custom-bredcrum-btn d-flex align-items-center">
                    <i [hidden]="item?.image_sq" class="{{ item?.icon }} me-1"></i>
                    <img [hidden]="!item?.image_sq" [src]="staticURL + item?.image_sq"
                      style="max-height: 1.2rem; max-width: 1.2rem" class="blacknWhite img-fluid me-1" />
                    {{ item?.label }}
                  </span>
                  <span class=""><i class="pi pi-fw pi-angle-left color-grey"></i></span>
                </span>
              </div>
              <!-- breadcrumb end -->
              <div class="overflow-ui">
                <p-accordion class="w-full p-accordian" [multiple]="true">
                  <p-accordionTab class="my-3 p-accordian" *ngFor="let field of side_view?.fields; let i = index" iconPos="end">
                    <ng-template class="p-accordian" pTemplate="header">
                      <div class="d-flex align-items-center color-grey">
                        <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                        <span class="vertical-align-middle font-1_1rem">{{
                          field.label?.name
                          }}</span>
                      </div>
                    </ng-template>
                    <ng-template class="p-accordian" pTemplate="content">
                      <div class="row">
                        <!-- For View -->
                        <div class="col-12">
                          <div [ngSwitch]="getFieldType(field.label?.type)">
                            <!-- For text -->
                            <div *ngSwitchCase="'text'">
                              <div class="d-flex flex-column mb-0 datacontent edited" *ngIf="field.data"
                                [innerHTML]="field.data | safeHTML"></div>
                            </div>
                            <!-- Rich text -->
                            <div *ngSwitchCase="'Rich text'">
                              <div class="d-flex flex-column mb-0 datacontent edited" *ngIf="field.data"
                                [innerHTML]="field.data | safeHTML"></div>
                            </div>
                            <div *ngSwitchCase="'Upload Image'">
                              <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                    GlobalConstants.staticFilesURL + field.data
                                  " />
                            </div>
                            <div *ngSwitchCase="'Upload Document'">
                              <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                    GlobalConstants.staticFilesURL + field.data
                                  ">
                                <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" | translator }}
                              </a>
                            </div>
                            <div *ngSwitchCase="'Data Item'">
                              <p-accordion class="w-full" [multiple]="true">
                                <p-accordionTab class="my-3 1300" *ngFor="
                                      let field of field.data.fields;
                                      let i = index
                                    " iconPos="end" [selected]="i == 0 || i == 1">
                                  <ng-template pTemplate="header">
                                    <div class="d-flex align-items-center color-grey">
                                      <i [ngClass]="
                                            field.label?.icon + ' font-1_2rem'
                                          " class="m-2"></i>
                                      <span class="vertical-align-middle font-1_1rem">{{ field.label?.name }}</span>
                                    </div>
                                  </ng-template>
                                  <ng-template pTemplate="content">
                                    <div class="row">
                                      <div class="col-10">
                                        <div [ngSwitch]="
                                              getFieldType(field.label?.type)
                                            ">
                                          <!-- For text -->
                                          <div *ngSwitchCase="'text'">
                                            <div class="d-flex flex-column mb-0 datacontent edited" *ngIf="field.data"
                                              [innerHTML]="
                                                  field.data | safeHTML
                                                "></div>
                                          </div>
                                          <!-- Rich text -->
                                          <div *ngSwitchCase="'Rich text'">
                                            <div class="d-flex flex-column mb-0 datacontent edited" *ngIf="field.data"
                                              [innerHTML]="
                                                  field.data | safeHTML
                                                "></div>
                                          </div>
                                          <div *ngSwitchCase="'Upload Image'">
                                            <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                                  GlobalConstants.staticFilesURL +
                                                  field.data
                                                " />
                                          </div>
                                          <div *ngSwitchCase="'Upload Document'">
                                            <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                                  GlobalConstants.staticFilesURL +
                                                  field.data
                                                ">
                                              <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" |
                                              translator }}
                                            </a>
                                          </div>
                                          <div *ngSwitchCase="'Data Item'"></div>
                                          <div *ngSwitchDefault>
                                            {{ field.data }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </ng-template>
                                </p-accordionTab>
                              </p-accordion>
                            </div>
                            <div *ngSwitchDefault>{{ field.data }}</div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>
                </p-accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End View Of the Service -->
    </div>
  </div>

  <!-- </div> -->
</div>
<!-- Search Section -->

<!-- search section end -->

<p-toast></p-toast>

<!-- Confirm Modal -->
<p-confirmDialog #cd [style]="{ width: '50vw' }">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="{{ 'cancellation' | translator }}"
      (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="{{ 'OK' | translator }}" (click)="cd.accept()"></button>
      </ng-template>
</p-confirmDialog>

<app-footer></app-footer>

<!-- breadcrumb -->
<!-- <div class="d-flex flex-row align-items-center wrapp">
    <span class="d-flex align-items-center my-1"
        *ngFor="let item of currentview.breadcrumbs; let i = index" [routerLink]="item.routerLink">
        <span class="custom-bredcrum-btn d-flex align-items-center">
            <i [hidden]="item.image_sq" class="{{item.icon}} me-1"></i>
            <img [hidden]="!item.image_sq" [src]="staticURL+item.image_sq"
                style="max-height: 1.2rem; max-width: 1.2rem;" class="blacknWhite img-fluid me-1">
            {{item.name}}
        </span>
        <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
    </span>
</div> -->
<!-- breadcrumb end -->